import { useEffect, useState } from 'react';

import API from '../../api/api';

export type AuthProviderCode =
  | 'identification-and-birthdate'
  | 'email-and-password'
  | 'claveunica'
  | 'google'
  | 'cross-app-redirect'
  | 'microsoft-entra-id';

export interface CampusAuthProviders {
  hasCredentials: boolean;
  hasMicrosoft: boolean;
  loading: boolean;
}

/**
 * Lee `auth-providers-campus.enableds` para que la vista de login
 * decida si muestra el formulario de credenciales, el botón Microsoft,
 * ambos o ninguno. Mientras carga devuelve `loading: true` para evitar
 * un flash con todo visible y luego ocultar.
 */
export function useCampusAuthProviders(): CampusAuthProviders {
  const [providers, setProviders] = useState<AuthProviderCode[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    API.get<{ providers: AuthProviderCode[] }>('/auth/campus-providers')
      .then((res) => {
        if (!cancelled) {
          setProviders(res.data.providers ?? []);
        }
      })
      .catch(() => {
        // Fallback conservador: si la setting no responde, dejamos solo
        // credenciales — comportamiento previo al feature de SSO.
        if (!cancelled) {
          setProviders(['email-and-password']);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    hasCredentials: providers?.includes('email-and-password') ?? false,
    hasMicrosoft: providers?.includes('microsoft-entra-id') ?? false,
    loading,
  };
}
